import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const pageTitleKeys: Record<string, string> = {
  "/": "pageTitles.dashboard",
  "/channel-session": "pageTitles.dashboard",
  "/chat-client": "pageTitles.chat",
  "/chat-jess": "pageTitles.chatJess",
  "/task-board": "pageTitles.taskBoard",
  "/process": "pageTitles.process",
  "/pages-starter": "pageTitles.starterPage",
  "/auth-login": "pageTitles.login",
  "/auth-register": "pageTitles.register",
  "/auth-changepassword": "pageTitles.changePassword",
  "/auth-lock-screen": "pageTitles.lockScreen",
  "/logout": "pageTitles.logout",
  "/auth-create-new-password": "pageTitles.createNewPassword",
  "/onboarding": "pageTitles.onboarding",
};

export const usePageTitle = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const path = location.pathname;
    const baseTitle = "Jesss";

    // Check if path includes dynamic segments (like :token)
    const titleKey =
      Object.entries(pageTitleKeys).find(([route]) => {
        if (route.includes(":")) {
          const routePattern = route.split("/");
          const pathSegments = path.split("/");

          if (routePattern.length !== pathSegments.length) return false;

          return routePattern.every((segment, index) => {
            return segment.startsWith(":") || segment === pathSegments[index];
          });
        }
        return route === path;
      })?.[1] || "pageTitles.dashboard";

    const pageTitle = t(titleKey);
    // Se o título já contém "Jesss", não adiciona o sufixo
    if (pageTitle.toLowerCase().includes("jesss")) {
      document.title = pageTitle;
    } else {
      document.title = `${pageTitle} - ${baseTitle}`;
    }
  }, [location, t, i18n.language]);
};
